import { Blue } from '../../constants';

export const defaultLoadingBarVars = {
  '--loading-bar-left-color': Blue.V100,
  '--loading-bar-right-color': Blue.V100,
} as const;
